import { render } from "./ConfirmEmailSent.vue?vue&type=template&id=4bc5f716"
import script from "./ConfirmEmailSent.vue?vue&type=script&lang=js"
export * from "./ConfirmEmailSent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__